import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/** Estado de carga: esqueletos de tarjetas (en línea) o velo con anillo (`fullscreen`). Sin imágenes ni recursos externos. */
@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  @Input() fullscreen = false;
}
